export var MINDSET_OPEN_WITH_MESSAGE_EVENT = 'mindset:open-with-message';

// Buffers a message dispatched before any listener has registered (e.g. a cold page load).
var pendingOpenMessage = null;

// Non-destructive: callers only clear it once they've actually acted on it
// (via clearPendingOpenMessage), so a guarded/declining consumer (e.g. the
// dock while hidden) doesn't destroy it for a later consumer/re-run that
// would have accepted it.
export function peekPendingOpenMessage() {
  return pendingOpenMessage;
}
export function clearPendingOpenMessage() {
  pendingOpenMessage = null;
}
export function openMindsetAgentWithMessage(message, options) {
  var _options$silent, _options$threadTitle, _options$coachingCont;
  var detail = {
    message: message,
    silent: (_options$silent = options === null || options === void 0 ? void 0 : options.silent) !== null && _options$silent !== void 0 ? _options$silent : false,
    threadTitle: (_options$threadTitle = options === null || options === void 0 ? void 0 : options.threadTitle) !== null && _options$threadTitle !== void 0 ? _options$threadTitle : '',
    coachingContext: (_options$coachingCont = options === null || options === void 0 ? void 0 : options.coachingContext) !== null && _options$coachingCont !== void 0 ? _options$coachingCont : ''
  };
  pendingOpenMessage = detail;
  window.dispatchEvent(new CustomEvent(MINDSET_OPEN_WITH_MESSAGE_EVENT, {
    detail: detail
  }));
}